document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('message-area');
  const windowElement = document.getElementById('window');
  const computingElement = document.getElementById('ooo-computing');
  const resultElement = document.getElementById('ooo-result');
  const oooInputs = document.querySelectorAll('.ooo-input');
  let keyDownProgress = 0;
  const oooList = document.getElementById('ooo-list');
  const fieldGroups = document.querySelectorAll('.ooo-field-group');
  const maxSlides = fieldGroups.length;
  const maxProgress = maxSlides - 2;
  
  // Store the generated message values
  let storedMessageValues = {};

  resetMessage();

  // Audio file paths
  const sounds = {
    loading: './build/sounds/loading.mp3',
    alert: './build/sounds/alert.mp3',
    email: './build/sounds/email.mp3',
    email2: './build/sounds/email2.mp3',
    inbox: './build/sounds/generate.mp3',
    trash: './build/sounds/trash.mp3',
    sent: './build/sounds/forward.mp3',
    error: './build/sounds/error.mp3',
    pop: './src/sounds/pop.mp3'
  };

  // Function to safely play sounds, always restarting
  function playSound(soundName) {
    try {
      const soundPath = sounds[soundName];
      if (soundPath) {
        const audio = new Audio(soundPath);
        audio.currentTime = 0;
        audio.play().catch(error => {
          //console.log(`Could not play ${soundName} sound:`, error);
        });
      }
    } catch (error) {
      //console.log(`Error playing ${soundName} sound:`, error);
    }
  }

  document.getElementById('btn-copy').addEventListener('click', () => {
    playSound('sent');
    handleCopyClick();
  });

  document.getElementById('btn-trash').addEventListener('click', () => {
    playSound('trash');
    resetMessage();
  });

  document.querySelectorAll('.btn').forEach(btn => {
    btn.addEventListener('click', function () {
      if (['btn-maximize', 'btn-minimize', 'btn-close'].includes(this.id)) {
        playSound('pop');
      }
      animateWindow(this);
    });
  });

  function animateWindow(button) {
    //console.log(button);
    windowElement.className = '';
    void windowElement.offsetWidth; // Force reflow

    if (button.id === 'btn-maximize') {
      windowElement.classList.add('animate__animated', 'animate__rubberBand');
    } else if (button.id === 'btn-minimize') {
      windowElement.classList.add('animate__animated', 'animate__bounce');
    } else if (button.id === 'btn-close') {
      windowElement.classList.add('animate__animated', 'animate__jello');
    } else if (button.id === 'btn-trash') {
      windowElement.classList.add('animate__animated', 'animate__backOutDown');
    }

    windowElement.addEventListener('animationend', () => {
      windowElement.classList.remove('animate__animated', 'animate__rubberBand', 'animate__bounce', 'animate__fadeOut', 'animate__jello', 'animate__backOutDown');
    }, { once: true });
  }

  document.querySelectorAll('.btn-next').forEach(btn => {
    btn.addEventListener('click', function () {
      const btnProgress = Number(this.dataset.progress);
      //console.log(btnProgress);
      keyDownProgress = btnProgress;
      progressList(btnProgress);
    });
  });

  function progressList(progress) {
    //console.log(progress);

    let valid = validateInput(progress);

    if (valid) {
      fieldGroups.forEach(group => group.classList.remove('current'));
    
    // Debug: Check if the index exists
      let targetIndex = Number(progress) + 1;
    console.log('progress:', progress, 'targetIndex:', targetIndex, 'fieldGroups.length:', fieldGroups.length);
    
    if (targetIndex < fieldGroups.length) {
      fieldGroups[targetIndex].classList.add('current');
      console.log('Added current class to fieldGroup at index:', targetIndex);
    } else {
      console.error('Invalid index:', targetIndex, 'for fieldGroups array of length:', fieldGroups.length);
    }

    
      playSound('alert');
      oooList.style.transform = `translateX(-${(progress + 1) * 100 / maxSlides}%)`;
    } else {
      //console.log(oooInputs[progress - 2]);
      playSound('error');
      oooInputs[progress - 1].classList.add('animate__animated', 'animate__shakeY', 'error');
      setTimeout(() => {
        oooInputs[progress - 1].classList.remove('animate__animated', 'animate__shakeY');
      }, 300);
    }

    if (progress == maxProgress - 1) {
      //console.log('computeMessag if');
      computeMessage();
    } else if (progress < maxProgress + 1) {
      //console.log('focus else');
      //oooInputs[progress].focus();
    }
  }

  function validateInput(progress) {
    if (progress >= 1 && progress < maxSlides) {
      if (oooInputs[progress - 1].value.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  function computeMessage() {
    playSound('loading');
    const loadingBar = document.querySelector('.ooo-computing-loading-bar');
    loadingBar.style.width = '10%';
    const interval = setInterval(() => {
      const width = parseInt(loadingBar.style.width) || 0;
      loadingBar.style.width = `${width + 10}%`;
    }, 200);
    setTimeout(() => {
      clearInterval(interval);
      //console.log('showMessage timeout');
      showMessage();
    }, 2000);
  }

  function toTitleCase(str) {
    return str.split(" ").map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(" ");
  }

  function resetMessage() {
    document.querySelectorAll('input').forEach(input => {
      input.value = "";
      input.classList.remove('error');
    });
    const loadingBar = document.querySelector('.ooo-computing-loading-bar');
    loadingBar.style.width = '0%';
    oooList.style.transform = `translateX(0%)`;
    document.getElementById('btn-copy').style.display = 'none';
    document.getElementById('ooo-result').innerHTML = '';
  }

  function showMessage() {

    //console.log('showMessage');

    oooList.style.transform = `translateX(-${(maxSlides - 1) * 100 / maxSlides}%)`;

    let vacationActivity = document.getElementById('vacation-activity').value.toLowerCase();
    let vacationItem = document.getElementById('vacation-item').value.toLowerCase();
    let drinkOfChoice = document.getElementById('drink-of-choice').value.toLowerCase();
    let favoriteCelebrity = toTitleCase(document.getElementById('favorite-celebrity').value);
    let firstName = toTitleCase(document.getElementById('first-name').value);

    // Store the values before clearing the inputs
    storedMessageValues = {
      vacationActivity,
      vacationItem,
      drinkOfChoice,
      favoriteCelebrity,
      firstName
    };

    document.querySelectorAll('input').forEach(input => {
      input.value = "";
      input.classList.remove('error');
    });

    document.getElementById('ooo-result').innerHTML = `
        <p>I'm currently out of office ${vacationActivity} somewhere far from my inbox. I've swapped my desk chair for a
          ${vacationItem} and my computer for a ${drinkOfChoice}. Regret it? Never.</p>
        <p>I'll be back someday. In the meantime, please forward requests to ${favoriteCelebrity}.</p>
        <p>See you when I'm back!<br>${firstName}</p>
    `;

    document.getElementById('btn-copy').style.display = 'flex';
  }

  function handleCopyClick() {
    // Use the stored values from when the message was generated
    let { vacationActivity, vacationItem, drinkOfChoice, favoriteCelebrity, firstName } = storedMessageValues;
    
    // Build the message with proper formatting for rich text editors
    let messageText = `I'm currently out of office ${vacationActivity} somewhere far from my inbox. I've swapped my desk chair for a ${vacationItem} and my computer for a ${drinkOfChoice}. Regret it? Never.

I'll be back someday. In the meantime, please forward requests to ${favoriteCelebrity}.

See you when I'm back!

${firstName}`;
    
    //console.log(messageText);
    navigator.clipboard.writeText(messageText).then(() => {
      const forwardBtn = document.getElementById('btn-copy');
      const tooltip = document.createElement('div');
      tooltip.textContent = 'Message copied to your clipboard!';
      tooltip.style.position = 'absolute';
      tooltip.style.backgroundColor = 'var(--gray-900)';
      tooltip.style.color = 'var(--white)';
      tooltip.style.padding = '0.5rem 1rem';
      tooltip.style.fontSize = '0.75rem';
      tooltip.style.zIndex = '1000';
      tooltip.style.bottom = '120%';
      tooltip.style.left = '50%';
      tooltip.style.transform = 'translateX(-50%)';
      tooltip.style.animation = 'fadeInOut 2s ease-in-out';
      
      forwardBtn.style.position = 'relative';
      forwardBtn.appendChild(tooltip);
      
      setTimeout(() => {
        tooltip.remove();
      }, 2000);
    });
  }

  const beerLogo = document.querySelector('.beer-logo');
  const beerImg = document.querySelector('.beer-logo img');

  beerImg.classList.add('animate__animated');

  // Track mouse position to skew the perspective of beerLogo
  document.addEventListener('mousemove', (e) => {
    const rect = beerLogo.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const maxSkew = 8; // degrees, more subtle
    const maxDistance = Math.min(window.innerWidth, window.innerHeight); // more subtle
    const dx = (e.clientX - centerX) / maxDistance;
    const dy = (e.clientY - centerY) / maxDistance;
    const rotateY = dx * maxSkew;
    const rotateX = -dy * maxSkew;
    beerLogo.style.transform = `perspective(600px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  });

  // Listen for Enter key to trigger the currently visible .btn-next
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      console.log('Enter key pressed');
      let currentIndex = Array.from(fieldGroups).findIndex(group => group.classList.contains('current'));
      console.log('currentIndex', currentIndex);
      console.log('maxProgress', maxProgress);
      // Log the current fieldGroup's btn-next data-progress value
      if (currentIndex < maxProgress) {
        const currentFieldGroup = fieldGroups[currentIndex];
        const btnNext = currentFieldGroup.querySelector('.btn-next');
        if (btnNext) {
          console.log('Current fieldGroup btn-next data-progress:', btnNext.dataset.progress);
        } else {
          console.log('No btn-next found in current fieldGroup');
        }
      }
      
      if (currentIndex < maxProgress) {
        progressList(currentIndex);
      }
    }
  });
}); 